













































import {Vue, Component} from 'vue-property-decorator';
import SkillDiagram from '@/components/SkillDiagram.vue';
import SkillDiagramWrapper from '@/components/SkillDiagramWrapper.vue';

@Component({
    name: 'Skills',
    components: {SkillDiagramWrapper, SkillDiagram},
})
export default class Skills extends Vue {

}
